
import { useEffect, useState } from "react";
import axios from "axios";
import { ErroMsg } from "../../frontend/contents/VariaveisGlobais";

async function ConsultaUsuario(){
    const URLRest = window._env_?.REACT_APP_URL_REST + "USUARIOS";
    const Token = window._env_?.REACT_APP_TOKEN_REST;
    // useEffect(() => {
        const usuarios = await axios.post(URLRest, {}, {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Basic ${Token}`,
                "Accept" : "*/*",
                "Cache-Control": "no-cache, no-store, must-revalidate",
                "Pragma": "no-cache",
                "Expires": "0",
            }})
            .then((response) => {
                return response.data;
            })
            .catch((err) => {
                ErroMsg('Falha ao Retornar Usuários!')
                return {data: [], error: err.message};
            });
    // }, []);

    return usuarios;
}

export default ConsultaUsuario